import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { profileAction } from "@redux/modules";
import showErrMessage from "@components/ShowErrMessage";
import showMessage from "@components/ShowMessage";
import Form from 'react-bootstrap/Form';

import BannerSendIdea from "@assets/images/banner-send-idea.jpg";

const SendIdea = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object({
    idea: yup
      .string()
      .required("Lütfen bir fikir giriniz!")
      .min(10, "Fikriniz en az 10 karakter olmalıdır!")
      .max(1000, "Fikriniz en fazla 1000 karakter olmalıdır!")
      .matches(
        /^[a-zA-ZğüşıöçĞÜŞİÖÇ0-9\s.,!?()-]+$/,
        "Fikriniz sadece harf, rakam ve temel noktalama işaretleri içerebilir!"
      ),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      await dispatch(profileAction.sendIdea(values.idea));
      showMessage("Çekilişe katıldınız tebrikler!");
      resetForm();
    } catch (err) {
      showErrMessage("Fikriniz Gönderilemedi. Bir Hata Oluştu!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <h2 className="mb-sm-6 mb-4">Fikir Gönder</h2>

      <h5 className="text-blue mb-sm-5 mb-4">Fikrini Gönder, Şansı Yakala!</h5>

      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        initialValues={{
          idea: "",
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit} className="mb-sm-6 mb-4">
            <div className="row g-5">
              <div className="col-md-6 order-md-0 order-1">
                <div className="mb-2">
                  <Form.Control
                    as="textarea"
                    className={`form-control ${
                      errors.idea && touched.idea ? "is-invalid" : ""
                    }`}
                    placeholder="Mesajınız"
                    style={{ height: "100px" }}
                    name="idea"
                    maxLength="1000"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.idea}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.idea && touched.idea && errors.idea}
                  </Form.Control.Feedback>
                </div>
                <span
                  className={`small d-block text-end mb-4${
                    1000 - values.idea.length <= 100 ? " text-red" : ""
                  }`}
                >
                  {1000 - values.idea.length} karakter kaldı.
                </span>
                <button
                  type="submit"
                  className="btn btn-blue py-sm-3 py-2 px-sm-4 px-3 w-100"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="spinner-border spinner-border-sm me-3"></span>
                  ) : null}
                  Gönder
                </button>
              </div>
              <div className="col-md-6 order-md-1 order-0">
                <img
                  src={BannerSendIdea}
                  alt="Banner Send Idea"
                  className="img-fluid rounded-3 mb-3"
                />
                <p className="mb-0 fw-light lh-lg">
                  Harika fikirlerin var ama paylaşacak bir yer mi arıyorsun?
                  Fikrini Gönder sayfamız tam sana göre! Burada bizimle
                  düşüncelerini, önerilerini ya da yaratıcı fikirlerini
                  paylaşarak sadece sesini duyurmakla kalmıyor, aynı zamanda her
                  fikrinle bir çekiliş hakkı kazanıyorsun. Ne kadar çok fikir, o
                  kadar çok şans!
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default SendIdea;
